var _path, _path2, _line;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnBtnRemoveEnd = function SvgIcnBtnRemoveEnd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H18C19.1046 0 20 0.895431 20 2V18C20 19.1046 19.1046 20 18 20H0V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.92916 5C8.46184 5 8.08301 5.37884 8.08301 5.84615V5.91667H11.7497V5.84615C11.7497 5.37884 11.3708 5 10.9035 5H8.92916ZM5.33301 7.67949C5.33301 7.21217 5.71184 6.83334 6.17916 6.83334H6.24981H13.5831H13.6535C14.1208 6.83334 14.4997 7.21217 14.4997 7.67949V7.82052C14.4997 8.28783 14.1208 8.66667 13.6535 8.66667H13.5831V14.1667C13.5831 15.1792 12.7623 16 11.7498 16H8.08315C7.07062 16 6.24981 15.1792 6.24981 14.1667V8.66667H6.17916C5.71184 8.66667 5.33301 8.28784 5.33301 7.82052V7.67949ZM12.6668 8.66667H7.16675V14.1667C7.16675 14.6729 7.57716 15.0833 8.08342 15.0833H11.7501C12.2563 15.0833 12.6668 14.6729 12.6668 14.1667V8.66667Z",
    fill: "#57595E"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 4.5,
    x2: 0.499999,
    y2: 15.5,
    stroke: "#DDDEE1",
    strokeLinecap: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnBtnRemoveEnd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_btn_remove_end.29ef1dfd.svg";
export { ForwardRef as ReactComponent };